// Recovered compiled webpack factory 14231. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { N: () => u });
  var n = r(38599),
    a = r(32191),
    o = r(36825);
  let i = -1,
    s = new Set(),
    l = (e) => {
      if (("pagehide" === e.type || n.j.document?.visibilityState === "hidden") && i > -1) {
        if ("visibilitychange" === e.type || "pagehide" === e.type) for (let e of s) e();
        isFinite(i) ||
          ((i = "visibilitychange" === e.type ? e.timeStamp : 0),
          (0, o.Q)("prerenderingchange", l, !0));
      }
    },
    u = () => {
      if (n.j.document && i < 0) {
        let e = (0, a.b)();
        ((i =
          (n.j.document.prerendering
            ? void 0
            : globalThis.performance
                .getEntriesByType("visibility-state")
                .filter((t) => "hidden" === t.name && t.startTime > e)[0]?.startTime) ??
          (n.j.document?.visibilityState !== "hidden" || n.j.document?.prerendering ? 1 / 0 : 0)),
          (0, o.d)("visibilitychange", l, !0),
          (0, o.d)("pagehide", l, !0),
          (0, o.d)("prerenderingchange", l, !0));
      }
      return {
        get firstHiddenTime() {
          return i;
        },
        onHidden(e) {
          s.add(e);
        },
      };
    };
}
